/**
 * Where an authentication failure sends someone (decision 48).
 *
 * Kept apart from the API client so the decision is one table rather than a
 * chain of conditions buried in a fetch wrapper — and so it can be tested
 * without a browser.
 */
export function routeForAuthError(code: string): "/login" | "/setup" | null {
  switch (code) {
    // No session, or the session was deleted by a forced sign-out
    // (decision 43): both mean "sign in again".
    case "unauthenticated":
    case "session_revoked":
      return "/login";

    // Signed in, but first-time setup is unfinished (design §5). Sending
    // these to /login would loop: they would sign in, land on the same
    // refusal, and be sent back to sign in.
    case "two_factor_required":
    case "password_change_required":
      return "/setup";

    default:
      // Includes `auth_not_configured`, which means nobody can sign in at
      // all — bouncing to /login would hide the one message explaining why.
      return null;
  }
}
